module.exports = __webpack_public_path__ + "static/img/m_modify_ed.17f9b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_modify_ed.png
// module id = Sf3Z
// module chunks = 9